import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MetaVendedor } from '../../services/local-meta-vendedor.service';

@Component({
  selector: 'app-detalle-meta-dialog',
  templateUrl: './detalle-meta-dialog.component.html',
  styleUrls: ['./detalle-meta-dialog.component.scss']
})
export class DetalleMetaDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    meta: MetaVendedor,
    vendedorNombre: string
  }) { }
}
